import SuperRepository from '../superRepository'

export default new (class BaselineCountryRequirementsRepository extends SuperRepository {
  baseUri() {
    return 'offer_partner_country_requirement'
  }
})()